import { Alert, Form, Input, Modal, Result, Row } from "antd"
import { Col24 } from "../Columns"
import { getInputRequiredRule } from "src/common/util"
import { FormActionButtons } from "../FormActionButtons"

interface Props {
    open: boolean
    title: string
    description: string
    onCancel: VoidFunction
    onAccept: VoidFunction
    actionLabel: string
    destroyKeyLabel: string
    destroyKeyValue: string
    acceptText: string
    cancelText: string
    isLoading: boolean
    errorMessage?: string
}

export const DestroyConfirmationModal = (props: Props) => {

    const [form] = Form.useForm();

    const onFinish = async (formValues) => {
        props.onAccept()
    }

    const getButtonStatus = (): boolean => {
        return !form.isFieldsTouched(true) ||
            form.getFieldsError().filter(({ errors }) => errors.length)
                .length > 0
    }

    const handleCancelClick = () => {
        props.onCancel()
    }

    const renderButtons = () => (
        <FormActionButtons
            cancelText={props.cancelText}
            actionText={props.acceptText}
            actionDisabled={getButtonStatus}
            onCancel={handleCancelClick}
            actionLoading={props.isLoading}
        />
    )

    const renderForm = () => (
        <Form
            form={form}
            layout="vertical"
            requiredMark={false}
            autoComplete={'none'}
            onFinish={onFinish}
        >
            <Row gutter={[16, 8]} >
                <Col24>
                    <Form.Item
                        label={""}
                        name={"confirmation"}
                        rules={[
                            getInputRequiredRule(props.destroyKeyLabel),
                            {
                                validator: (_, value) => {
                                    if (value !== props.destroyKeyValue) {
                                        return Promise.reject("")
                                    }

                                    return Promise.resolve()
                                }
                            },
                        ]}
                        validateTrigger="onBlur"
                    >
                        <Input
                            placeholder={props.destroyKeyValue}
                        />
                    </Form.Item>
                </Col24>
            </Row>
            {
                props.errorMessage &&
                <Alert
                    message={"Error"}
                    showIcon
                    description={props.errorMessage}
                    type="error"
                    style={{
                        marginBottom: 12,
                    }}
                />
            }
            {renderButtons()}
        </Form>
    )

    return (
        <Modal
            title=""
            centered
            open={props.open}
            width={500}
            okText={props.onAccept}
            cancelText={props.onCancel}
            footer={<></>}
            closable={false}
            zIndex={1200}
            getContainer={false}
        >
            <Result
                status={"warning"}
                title={props.title}
                subTitle={props.description}
                style={{ marginBottom: -40 }}
            />
            {renderForm()}
        </Modal>
    )
}
